import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ds-card-title',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @switch (level()) {
      @case (2) {
        <h2 class="ds-card-title"><ng-content /></h2>
      }
      @case (4) {
        <h4 class="ds-card-title"><ng-content /></h4>
      }
      @default {
        <h3 class="ds-card-title"><ng-content /></h3>
      }
    }
  `,
  styles: [`
    .ds-card-title {
      font-family: var(--f-display);
      font-weight: 600;
      line-height: 1.25;
      letter-spacing: -0.01em;
      margin: 0;
    }

    h2.ds-card-title { font-size: 28px; }
    h3.ds-card-title { font-size: 22px; }
    h4.ds-card-title { font-size: 18px; }
  `],
})
export class DsCardTitleComponent {
  readonly level = input<2 | 3 | 4>(3);
}
